import { getDisplayDate } from "./GetDisplayDate";

const PrintComponent = ({ record, printType = "FULL" }) => {
    const data = record;
    const isIndoNepal =
      data.prabhuPinNo  !== undefined ||
      data.partnerPinNo !== undefined ||
      data.transactionType === "INDO_NEPAL";

    /* ===================== THERMAL ===================== */
    if (printType === "THERMAL") {
        return (
            <div className="w-[80mm] bg-white p-2 text-[11px] font-mono leading-tight">

                {/* HEADER */}
                <div className="text-center mb-2">
                    <p className="font-semibold">Shop Details</p>
                    <p className="font-bold uppercase">
                        {data.shopName || data.merchantName}
                    </p>
                    <p>Mobile : {data.merchant_mobile}</p>
                    <p className="font-bold mt-1 text-sm">
                        Amount : ₹{isIndoNepal ? Number(data.sendAmount || 0).toFixed(2) : (data.netAmount || data.amount)}
                    </p>
                    <p className="font-bold mt-1 text-sm">
                        Status : {data.status || data.txnStatus}
                    </p>
                </div>

                <hr className="border-dashed my-1" />

                {/* TXN INFO */}
                <div className="space-y-[2px]">
                    <p><b>Date :</b> {getDisplayDate(isIndoNepal ? (data.createdAt || data.date) : (data.rawDate || data.date))}</p>
                    <p><b>{isIndoNepal ? "PIN" : "Txn ID"} :</b> {isIndoNepal ? (data.prabhuPinNo || data.externalRefNo || "—") : data.txnId}</p>
                    {!isIndoNepal && <p><b>Mode :</b> {data.paymentMode || data.aeps_txn_mode}</p>}
                </div>

                {/* INDO-NEPAL: Partner PIN + Customer ID */}
                {isIndoNepal && (
                    <>
                        <hr className="border-dashed my-1" />
                        <div className="space-y-[2px]">
                            <p className="font-semibold">PIN Details</p>
                            <p>Partner PIN : {data.partnerPinNo || data.thirdPartyTxnId || "—"}</p>
                            {(data.senderCustomerId) && <p>Customer ID : {data.senderCustomerId}</p>}
                        </div>
                    </>
                )}

                <hr className="border-dashed my-1" />

                {/* OPERATOR */}
                {data.operator && (
                    <div className="space-y-[2px]">
                        <p className="font-semibold">Operator Details</p>
                        <p>Operator : {data.operator}</p>
                        {data.consumerNumber && <p>Consumer No : {data.consumerNumber}</p>}
                    </div>
                )}

                {/* AEPS CUSTOMER */}
                {data.aeps_txn_mode && (
                    <div className="space-y-[2px]">
                        <p className="font-semibold">Customer Details</p>
                        {data.aeps_AadhaarNo && <p>Aadhaar : {data.aeps_AadhaarNo}</p>}
                        {data.beneficiaryMobileNumber && <p>Mobile : {data.beneficiaryMobileNumber}</p>}
                    </div>
                )}

                {/* CCBP */}
                {data.biller_Id && data.consumer_number && (
                    <div className="space-y-[2px]">
                        <p className="font-semibold">Customer Details</p>
                        <p>Consumer Number : {data.consumer_number}</p>
                    </div>
                )}

                {/* NORMAL / INDO-NEPAL CUSTOMER */}
                {!data.operator && !data.aeps_txn_mode && (
                    <div className="space-y-[2px]">
                        <p className="font-semibold">{isIndoNepal ? "Sender" : "Customer"} Details</p>
                        {(isIndoNepal ? (data.senderName || data.fullName) : (data.customerName || data.remitterName)) && (
                            <p>Name : {isIndoNepal ? (data.senderName || data.fullName) : (data.customerName || data.remitterName)}</p>
                        )}
                        {(isIndoNepal ? data.senderMobile : (data.customerMobile || data.remitterMobileNumber)) && (
                            <p>Mobile : {isIndoNepal ? data.senderMobile : (data.customerMobile || data.remitterMobileNumber)}</p>
                        )}
                        {data.utr && <p>UTR : {data.utr}</p>}
                        {data.bankRrn && <p><b>Bank RRN :</b> {data.bankRrn}</p>}
                    </div>
                )}

                <hr className="border-dashed my-1" />

                {/* BENEFICIARY / INDO-NEPAL RECEIVER */}
                {!data.operator && (
                    <div className="space-y-[2px]">
                        <p className="font-semibold">{isIndoNepal ? "Receiver" : "Beneficiary"} Details</p>
                        <p>Name : {isIndoNepal ? (data.receiverName || data.consumerOrBeneficiary || "—") : (data.beneficiary_name || data.beneficiaryName || "")}</p>
                        {isIndoNepal
                            ? <p>Partner PIN : {data.partnerPinNo || data.thirdPartyTxnId || "—"}</p>
                            : <>
                                {(data.beneficiary_account_number || data.beneficiaryAccountNo) && (
                                    <p className="break-all">A/C : {data.beneficiary_account_number || data.beneficiaryAccountNo}</p>
                                )}
                                {data.beneBankName && <p>Bank : {data.beneBankName}</p>}
                              </>
                        }
                    </div>
                )}

                {/* INDO-NEPAL: Amount breakdown */}
                {isIndoNepal && (
                    <>
                        <hr className="border-dashed my-1" />
                        <div className="space-y-[2px]">
                            <p className="font-semibold">Amount Details</p>
                            <p>Send Amount    : INR {Number(data.sendAmount || data.txnAmount || 0).toFixed(2)}</p>
                            <p>Service Charge : INR {Number(data.serviceCharge !== undefined ? data.serviceCharge : (data.netAmount && data.txnAmount ? data.netAmount - data.txnAmount : 0)).toFixed(2)}</p>
                            {data.payAmount   != null && <p>Amount in NPR  : NPR {Number(data.payAmount).toFixed(2)}</p>}
                            <p>Rate           : 1 INR = {data.exchangeRate != null ? Number(data.exchangeRate).toFixed(4) : "1.6000"} NPR</p>
                        </div>
                    </>
                )}
            </div>
        );
    }

    /* ===================== SHORT ===================== */
    if (printType === "SHORT") {
        return (
            <div className="w-full flex justify-start">
                <div className="w-full max-w-[420px] border border-gray-300 bg-white p-2 text-[11px] leading-tight">

                    <div className="grid grid-cols-[140px_1fr] gap-2">

                        <div className="border-r pr-2 space-y-2">
                            <p className="font-bold uppercase">
                                {data.shopName || data.merchantName}
                            </p>
                            <p>Mob: {data.merchant_mobile}</p>
                            <p className="font-bold">₹ {data.netAmount || data.amount}</p>
                        </div>

                        <table className="w-full text-[10px]">
                            <tbody>
                                <tr><td>Date</td><td>{getDisplayDate(data.rawDate || data.date)}</td></tr>
                                <tr><td>Txn</td><td>{data.txnId}</td></tr>
                                <tr><td>Mode</td><td>{data.paymentMode}</td></tr>
                                <tr><td>Status</td><td className="font-bold">{data.status}</td></tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        );
    }

    /* ===================== FULL ===================== */
    return (
        <div className="w-full flex justify-center">
            <div className="w-full max-w-[800px] bg-white text-sm">

                <div className="border border-gray-400 p-4 space-y-3">

                    {/* TOP GRID */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                        <div>
                            <p className="font-semibold">Shop</p>
                            <p className="font-bold uppercase text-base">
                                {data.shopName || data.merchantName}
                            </p>
                            <p>Mob : {data.merchant_mobile}</p>
                        </div>

                        {/* OPERATOR */}
                        {data.operator && (
                            <div>
                                <p className="font-semibold">Operator</p>
                                <p>{data.operator}</p>
                                {data.consumerNumber && <p>CN : {data.consumerNumber}</p>}
                            </div>
                        )}

                        {/* AEPS CUSTOMER */}
                        {data.aeps_txn_mode && (
                            <div>
                                <p className="font-semibold">Customer</p>
                                {data.aeps_AadhaarNo && <p>Aadhaar : {data.aeps_AadhaarNo}</p>}
                                {data.beneficiaryMobileNumber && (
                                    <p>Mobile : {data.beneficiaryMobileNumber}</p>
                                )}
                            </div>
                        )}

                        {data.biller_Id && data.consumer_number && (
                            <div className="space-y-[2px]">
                                <p className="font-semibold">Biller Details</p>
                                <p>Biller ID : {data.biller_Id}</p>
                                <p>Consumer Number : {data.consumer_number}</p>
                            </div>
                        )}
                        {/* NORMAL / INDO-NEPAL CUSTOMER */}
                        {!data.operator && !data.aeps_txn_mode && !data.biller_Id && (
                            <div className="space-y-[2px]">
                                <p className="font-semibold">{isIndoNepal ? "Sender" : "Customer"} Details</p>
                                {(isIndoNepal ? (data.senderName || data.fullName) : (data.customerName || data.remitterName)) && (
                                    <p>Name : {isIndoNepal ? (data.senderName || data.fullName) : (data.customerName || data.remitterName)}</p>
                                )}
                                {(isIndoNepal ? data.senderMobile : (data.customerMobile || data.remitterMobileNumber)) && (
                                    <p>Mobile : {isIndoNepal ? data.senderMobile : (data.customerMobile || data.remitterMobileNumber)}</p>
                                )}
                                {data.utr && <p>UTR : {data.utr}</p>}
                                {data.bankRrn && <p><b>Bank RRN :</b> {data.bankRrn}</p>}
                            </div>
                        )}

                        {/* BENEFICIARY / INDO-NEPAL RECEIVER */}
                        {!data.operator && !data.biller_Id && (
                            <div className="space-y-[2px]">
                                <p className="font-semibold">{isIndoNepal ? "Receiver" : "Beneficiary"} Details</p>
                                <p>Name : {isIndoNepal ? (data.receiverName || data.consumerOrBeneficiary || "—") : (data.beneficiary_name || data.beneficiaryName || "")}</p>
                                {isIndoNepal
                                    ? <>
                                        <p>Partner PIN : {data.partnerPinNo || data.thirdPartyTxnId || "—"}</p>
                                        {data.senderCustomerId && <p>Customer ID : {data.senderCustomerId}</p>}
                                      </>
                                    : <>
                                        {(data.beneficiary_account_number || data.beneficiaryAccountNo) && (
                                            <p className="break-all">A/C : {data.beneficiary_account_number || data.beneficiaryAccountNo}</p>
                                        )}
                                        {data.beneBankName && <p>Bank : {data.beneBankName}</p>}
                                      </>
                                }
                            </div>
                        )}
                    </div>

                    {/* TXN INFO */}
                    <div className="border-t pt-2 text-xs flex flex-wrap gap-x-4">
                        <p><b>Date:</b> {getDisplayDate(isIndoNepal ? (data.createdAt || data.date) : (data.rawDate || data.date))}</p>
                        <p><b>{isIndoNepal ? "PIN" : "Txn"}:</b> {isIndoNepal ? (data.prabhuPinNo || data.externalRefNo || "—") : data.txnId}</p>
                        {!isIndoNepal && <p><b>Mode:</b> {data.paymentMode || data.aeps_txn_mode}</p>}
                        <p>
                            <b>Status:</b>{" "}
                            <span className="font-bold uppercase">{data.status || data.txnStatus}</span>
                        </p>
                    </div>

                    {/* AMOUNT */}
                    <div className="border border-dashed text-center py-3">
                        <p className="font-semibold">{isIndoNepal ? "Send Amount" : "Amount"}</p>
                        <p className="text-2xl font-bold">
                            ₹{isIndoNepal ? Number(data.sendAmount || data.txnAmount || 0).toFixed(2) : (data.netAmount || data.amount)}
                        </p>
                        {isIndoNepal && (
                            <>
                                <p className="text-sm text-gray-500 mt-1">
                                    + ₹{Number(data.serviceCharge !== undefined ? data.serviceCharge : (data.netAmount && data.txnAmount ? data.netAmount - data.txnAmount : 0)).toFixed(2)} charge
                                </p>
                                {data.payAmount    != null && <p className="text-lg font-bold text-[#0A2A4F] mt-1">NPR {Number(data.payAmount).toFixed(2)}</p>}
                                <p className="text-xs text-gray-400 mt-0.5">1 INR = {data.exchangeRate != null ? Number(data.exchangeRate).toFixed(4) : "1.6000"} NPR</p>
                            </>
                        )}
                    </div>

                    {/* DISCLAIMER */}
                    <ul className="list-disc pl-5 text-sm">
                        <li>This is a system generated receipt.</li>
                        <li>Customer is responsible for provided details.</li>
                        <li>लेन-देन में हुई त्रुटि से संबंधित शिकायतों के निवारण में 24 से 48 कार्य घंटे लग सकते हैं।</li>
                        <li>Resolution of complaints related to transaction errors may take 24 to 48 working hours.</li>
                    </ul>

                </div>
            </div>
        </div>
    );
};

export default PrintComponent;


